import { z } from 'zod';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { ApiResponse, axiosInstance, AxiosErrorCustom } from '@/lib/axios';
import { TAgent } from '../types/agent.type';

/**
 *
 */
export const InviteAgentValidationSchema = z.object({
  fullname: z
    .string()
    .min(1, { message: 'Full name is required' })
    .max(100, { message: 'Full name must be at most 100 characters' }),

  email: z.string().min(1, { message: 'Email is required' }).email({ message: 'Invalid email format' }),

  teamIds: z
    .array(z.string({ message: 'Team ID must be a string' }))
    .nonempty({ message: 'At least one team must be selected' })
    .optional(),
});
export type TInviteAgentValidation = z.infer<typeof InviteAgentValidationSchema>;
export type TInviteAgentPayload = TInviteAgentValidation;
export type TInviteAgentResponse = ApiResponse<TAgent>;

export const inviteAgent = async (payload: TInviteAgentPayload): Promise<TInviteAgentResponse> => {
  const url = '/invitation';

  return axiosInstance.post(url, payload);
};

/**
 *  Return query key for invite agent
 */
type UseInviteAgentOptions = {
  mutationConfig?: TypedMutationConfig<typeof inviteAgent, AxiosErrorCustom>;
};

export const useInviteAgent = ({ mutationConfig }: UseInviteAgentOptions) => {
  const { ...restConfig } = mutationConfig || {};

  return useMutation<TInviteAgentResponse, AxiosErrorCustom, TInviteAgentValidation>({
    mutationFn: inviteAgent,
    ...restConfig,
  });
};
